import { render, staticRenderFns } from "./OrdersStatistics.vue?vue&type=template&id=4292c192&scoped=true&"
import script from "./OrdersStatistics.vue?vue&type=script&lang=js&"
export * from "./OrdersStatistics.vue?vue&type=script&lang=js&"
import style0 from "./OrdersStatistics.vue?vue&type=style&index=0&id=4292c192&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4292c192",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
